import get from 'lodash/get'
import deepmerge from 'deepmerge'
export const UPDATE_LABELS = 'UPDATE_LABELS'

export const labels = {
  state: {
    translations: {},
  },
  getters: {
    translation: (state) => (key) => get(state.translations, key, key),
  },
  mutations: {
    [UPDATE_LABELS]: function (state, payload) {
      state.translations = deepmerge(state.translations, payload)
    },
  },
  // actions,
}
